// extracted by mini-css-extract-plugin
export var backgroundCoverCenter = "banner-module--background-cover-center--2v7oj";
export var backgroundCoverTop = "banner-module--background-cover-top--3eDi_";
export var backgroundContainTop = "banner-module--background-contain-top--1xNAM";
export var backgroundContainCenter = "banner-module--background-contain-center--2qQDO";
export var backgroundContainLeft = "banner-module--background-contain-left--33lLJ";
export var sgaBanner = "banner-module--sgaBanner--tfL8h";
export var sgaBannerLeft = "banner-module--sgaBannerLeft--xy0f0";
export var sgaBannerHeading = "banner-module--sgaBannerHeading--2JhGj";
export var sgaBannerSubHeadingContainer = "banner-module--sgaBannerSubHeadingContainer--2LJXk";
export var sgaBannerSubHeading = "banner-module--sgaBannerSubHeading--1zSWI";
export var sgaLink = "banner-module--sgaLink--2P1oj";
export var sgaBannerRight = "banner-module--sgaBannerRight--gMGOD";
export var sgaBannerImg = "banner-module--sgaBannerImg--zW5OK";